module.exports = __webpack_public_path__ + "static/media/methodo.43cb37d6.jpg";